RivalIQ.module('export.collections', function (collections, App, Backbone, Marionette, $, _) {
    'use strict';

    const sortOrder = [
        RivalIQ.export.format.CSV,
        RivalIQ.export.format.PNG,
        RivalIQ.export.format.PDF,
        RivalIQ.export.format.PPT
    ];

    collections.Types = Backbone.Collection.extend({
        comparator: function (option) {
            return sortOrder.indexOf(option.get('format'));
        }
    });
});
